export default "__VITE_ASSET__DLWyjT8d__"